import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  Rozpuszczalnik,
  rozpuszczalnikResource,
} from "@megarax/client/src/resources/plm";

export const rozpuszczalnikModule: ResourceAppModule = {
  app: plmApp,
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  title: "Rozpuszczalniki",
  route: "rozpuszczalnik",
  itemConstructor: Rozpuszczalnik,
  resource: rozpuszczalnikResource,
};
